import React from "react";

const MessageIcon = ({height, width}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "block", margin: "auto" }}>
      <rect x="0.5" y="0.5" width="39" height="35" rx="4.5" stroke="white" />
      <path
        d="M14 10.5H27C27.7956 10.5 28.5587 10.8161 29.1213 11.3787C29.6839 11.9413 30 12.7044 30 13.5V22.5C30 23.2957 29.6839 24.0587 29.1213 24.6213C28.5587 25.1839 27.7956 25.5 27 25.5H14C13.2044 25.5 12.4413 25.1839 11.8787 24.6213C11.3161 24.0587 11 23.2957 11 22.5V13.5C11 12.7044 11.3161 11.9413 11.8787 11.3787C12.4413 10.8161 13.2044 10.5 14 10.5ZM14 11.5C13.5 11.5 13.06 11.67 12.72 11.97L20.5 17L28.28 11.97C27.94 11.67 27.5 11.5 27 11.5H14ZM20.5 18.21L12.13 12.78C12.05 13 12 13.25 12 13.5V22.5C12 23.0304 12.2107 23.5391 12.5858 23.9142C12.9609 24.2893 13.4696 24.5 14 24.5H27C27.5304 24.5 28.0391 24.2893 28.4142 23.9142C28.7893 23.5391 29 23.0304 29 22.5V13.5C29 13.25 28.95 13 28.87 12.78L20.5 18.21Z"
        fill="white"
      />
    </svg>
  );
};

export default MessageIcon;
